import { defineStore } from "pinia";
import _ from "lodash";
import * as storeHelper from "@/shared/storeHelper";
import { BrowserState, browserMap } from "@/shared/types";
import { getBrowserParser } from "@/shared/browserDetect";
import { getEmployeeBrowserRules } from "@/shared/api/userService";
import * as datadog from "@/shared/datadog";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { isMobileApp } from "@/shared/mobileHelper";

export const initialState: BrowserState = {
  deviceInfo: null,
  browserRules: null,
  isUnsupported: false,
  minVersion: 0
};

export const useBrowserStore = defineStore("browser", {
  state: () => (_.cloneDeep(initialState)),
  getters: {
    browser: state => _.get(state.deviceInfo, "browser.name"),
    browserVersion: state => _.get(state.deviceInfo, "browser.version")
  },
  actions: {
    checkBrowser () {
      if (isMobileApp()) {
        return;
      }

      const featureFlagStore = useFeatureFlagStore();
      if (!featureFlagStore.flags.bend31868BrowserVersionEnforcement) {
        return;
      }

      getEmployeeBrowserRules()
        .then(response => {
          this.browserRules = response.data.browserRules;

          const parser = getBrowserParser();
          const deviceInfo = parser.getResult();

          this.deviceInfo = deviceInfo;

          if (!deviceInfo.browser.name) {
            return;
          }

          const browser = browserMap[deviceInfo.browser.name];
          if (!browser) {
            return;
          }

          const minVersion = response.data.browserRules[browser];
          if (!minVersion) {
            return;
          }

          this.minVersion = minVersion;

          const rules = _.mapValues(response.data.browserRules, minVersion => `>=${minVersion}`);
          const isUnsupported = parser.satisfies(rules) === false;

          this.isUnsupported = isUnsupported;

          if (isUnsupported) {
            datadog.log("Unsupported browser version detected", {}, "warn");
          }
        })
        .catch(error => {
          return storeHelper.handleError({ error, rethrow: false });
        });
    }
  }
});
